/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Board_Write_SendInputs */

const en_us2_board_write_send = /** @type {(inputs: Board_Write_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send for review`)
};

const pt_br2_board_write_send = /** @type {(inputs: Board_Write_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar para análise`)
};

const pt_pt2_board_write_send = /** @type {(inputs: Board_Write_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar para análise`)
};

/** @type {(inputs: Board_Write_SendInputs) => LocalizedString} */
const es_419_board_write_send = en_us2_board_write_send;

/** @type {(inputs: Board_Write_SendInputs) => LocalizedString} */
const fr_fr2_board_write_send = en_us2_board_write_send;

/** @type {(inputs: Board_Write_SendInputs) => LocalizedString} */
const de_de2_board_write_send = en_us2_board_write_send;

/** @type {(inputs: Board_Write_SendInputs) => LocalizedString} */
const it_it2_board_write_send = en_us2_board_write_send;

/**
* | output |
* | --- |
* | "Send for review" |
*
* @param {Board_Write_SendInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const board_write_send = /** @type {((inputs?: Board_Write_SendInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Board_Write_SendInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_board_write_send(inputs)
	if (locale === "es-419") return es_419_board_write_send(inputs)
	if (locale === "pt-PT") return pt_pt2_board_write_send(inputs)
	if (locale === "fr-FR") return fr_fr2_board_write_send(inputs)
	if (locale === "de-DE") return de_de2_board_write_send(inputs)
	if (locale === "it-IT") return it_it2_board_write_send(inputs)
	return en_us2_board_write_send(inputs)
});
export { board_write_send as "board.write_send" }